import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
//----  Navegacion  ----
import { HashRouter } from 'react-router-dom';
//----  REDUX ----
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/lib/integration/react';
import configureStore from './config/store';
//----  REDUX ----
import { createBrowserHistory } from "history";
// Importing the Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import { createRoot } from 'react-dom/client';
//import { store, persistor } from './store'; // ajusta si está en otro archivo


//import registerServiceWorker from './registerServiceWorker';

//const history = createBrowserHistory();
const { store, persistor } = configureStore(); 

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <HashRouter>
        <App/>
      </HashRouter>
    </PersistGate>
  </Provider> );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
//registerServiceWorker();